import { DEVICE_HEIGHT, DEVICE_WIDTH } from './constants';

/** Below this the replica stops being readable; above it, pixelated. */
export const MIN_SCALE = 0.7;
export const MAX_SCALE = 2;

/** Room left under the phone so the host page never has to scroll for it. */
export const BOTTOM_ROOM = 120;

interface Budget {
  /** Host column width, in CSS px. */
  width: number;
  /** Viewport height left below the frame's top edge, in CSS px. */
  height: number;
}

/**
 * The largest whole-device scale that fits both budgets. A non-positive or
 * unknown budget means "not measured yet" and simply does not constrain —
 * an unmeasured axis must not collapse the phone to the minimum.
 */
export const fitDeviceScale = ({ width, height }: Budget): number => {
  const ratios = [width / DEVICE_WIDTH, height / DEVICE_HEIGHT].filter(
    (ratio) => Number.isFinite(ratio) && ratio > 0
  );
  const fit = ratios.length ? Math.min(...ratios) : 1;
  return Math.min(Math.max(fit, MIN_SCALE), MAX_SCALE);
};

/** Viewport room below the frame's top edge, minus breathing space. */
export const heightBudget = (top: number, viewportHeight: number): number =>
  viewportHeight - top - BOTTOM_ROOM;
